import React from "react";
import { twMerge } from "tailwind-merge";

import { Loader } from "..";

type ButtonProps = {
  isLoading?: boolean;
  variant?: "outlined" | "text" | "contained";
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button: React.FC<ButtonProps> = ({
  children,
  className,
  variant = "outlined",
  isLoading = false,
  disabled,
  ...props
}) => {
  const textClassNames = [
    "bg-transparent",
    "text-primary",
    !disabled && "hover:bg-indigo-50",
    !disabled && "hover:text-indigo-800",
  ];
  const outlinedClassNames = [
    "bg-white",
    "text-primary",
    "border",
    "border-gray-500",
    !disabled && "hover:border-indigo-800",
    !disabled && "hover:bg-indigo-50",
    !disabled && "hover:text-indigo-800",
  ];
  const containedClassNames = [
    "border",
    "border-primary",
    "bg-primary",
    "text-primary-contrast",
    "transition-colors",
    "duration-300",
    (disabled || isLoading) && "opacity-50",
    !disabled && !isLoading && "hover:bg-primaryHover",
    !disabled && !isLoading && "hover:text-primary-contrast",
  ];

  const variantClassNames = (() => {
    if (variant === "outlined") return outlinedClassNames;

    if (variant === "contained") return containedClassNames;

    if (variant === "text") return textClassNames;

    return [];
  })();

  return (
    <button
      disabled={isLoading || disabled}
      className={twMerge(
        "flex",
        "flex-row",
        "justify-center",
        "items-center",
        "gap-3",
        "text-base",
        "py-1.5",
        "px-5",
        "rounded-lg",
        "text-center",
        "font-normal",
        !disabled && !isLoading && "hover:shadow-lg",
        !disabled && !isLoading && "hover:border-transparent",
        variantClassNames,
        isLoading && "disabled",
        className,
      )}
      {...props}
    >
      {isLoading && <Loader size={16} className="border-gray-300" />}
      {children}
    </button>
  );
};
